import {defaultSvgProps, SvgProps} from '../type/props'

export const DataDownloadUsersIcon = (props?: SvgProps) => {
  const {width, height, fill, stroke, style} = defaultSvgProps(props, {
    width: 16,
    height: 16,
    fill: 'none',
    stroke: 'currentColor',
    style: {
      flexShrink: 0,
    },
  })

  return (
    <svg
      viewBox='0 0 24 24'
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      style={style}>
      <path d='M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2' />
      <circle cx='9' cy='7' r='4' />
      <path d='M22 21v-2a4 4 0 00-3-3.87' />
      <path d='M16 3.13a4 4 0 010 7.75' />
    </svg>
  )
}
